import { render } from "./CompanySettings.vue?vue&type=template&id=1de60616&ts=true"
import script from "./CompanySettings.vue?vue&type=script&lang=ts"
export * from "./CompanySettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__